(() => {
  const withPreview = value => {
    const url = new URL(value, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-linked-pack-select]')) location.assign(withPreview(event.target.value));
  });
  const init = scope => scope.querySelectorAll('[data-linked-pack]').forEach(link => {
    link.href = withPreview(link.getAttribute('href'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
